import { useState, useCallback } from 'react';

import { startCrossTabAuthSync, syncReactiveAuthVariables } from './authReactiveVariables';

export const useInitSession = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const initializeSession = useCallback(async () => {
    if (isInitialized) return;

    setIsLoading(true);
    setError(null);

    try {
      startCrossTabAuthSync();
      syncReactiveAuthVariables();
      setIsInitialized(true);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Failed to initialize session'));
    } finally {
      setIsLoading(false);
    }
  }, [isInitialized]);

  return {
    initializeSession,
    isLoading,
    isInitialized,
    error,
  };
};
